import '../../styles/App.css';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import { difficultiesNames, patchPeriods, factions, modifierNames } from '../../constants';
import { capitalizeFirstLetter } from '../../utils/utils';

function GamesFilters({ filters, setFilters }) {
    
    return (
        <div className="filters-container">
            <div className="filter-container">
                <DropdownButton
                    className="dropdown-button"
                    title={"Faction: " + capitalizeFirstLetter(filters.faction)}>
                    {factions.map((factionName) => (
                        <Dropdown.Item
                            as="button"
                            onClick={() => {  setFilters({ ...filters, faction: factionName , modifier: "ALL" }); }}>
                            {capitalizeFirstLetter(factionName)}
                        </Dropdown.Item>
                    ))}
                </DropdownButton>
            </div>
            <div className="filter-container">
                <DropdownButton
                    className="dropdown-button"
                    title={`${'Modifier: '}${capitalizeFirstLetter(filters.modifier)}`}>
                    {modifierNames[filters.faction].map((modifierName) => (
                        <Dropdown.Item
                            as="button"
                            onClick={() => { setFilters({ ...filters, modifier: modifierName }); }}>
                            {modifierName}
                        </Dropdown.Item>
                    ))}
                </DropdownButton>
            </div>
            <div className="filter-container">
                <DropdownButton
                    className="dropdown-button"
                    title={'Patch: ' + filters.patch.name}>
                    {patchPeriods.slice().reverse().map((patchPeriod, index) => (
                        <Dropdown.Item
                            as="button"
                            onClick={() => { setFilters({ ...filters, patch: patchPeriod }); }}>
                            {`${patchPeriod.name}`}
                        </Dropdown.Item>
                    ))}
                </DropdownButton>
            </div>
            <div className="filter-container">
                <DropdownButton
                    className="dropdown-button"
                    title={
                        filters.difficulty === 0
                            ? "Difficulty: All"
                            : "Difficulty: " + filters.difficulty
                    }>
                    {difficultiesNames.map((diffName, diffIndex) => (
                        <Dropdown.Item
                            as="button"
                            onClick={() => {
                                setFilters({
                                    ...filters,
                                    difficulty: diffName === "All" ? 0 : (6 + diffIndex)
                                });
                            }}>
                            {diffName}
                        </Dropdown.Item>
                    ))}
                </DropdownButton>
            </div>
            <div className="filter-container">
                <DropdownButton
                    className="dropdown-button"
                    title={"Mission Type: " + filters.mission}>
                    <Dropdown.Item
                        as="button"
                        onClick={() => { setFilters({ ...filters, mission: "All" }); }}>
                        All
                    </Dropdown.Item>
                    <Dropdown.Item
                        as="button"
                        onClick={() => { setFilters({ ...filters, mission: "Long" }); }}>
                        Long
                    </Dropdown.Item>
                    <Dropdown.Item
                        as="button"
                        onClick={() => { setFilters({ ...filters, mission: "Short" }); }}>
                        Short
                    </Dropdown.Item>
                </DropdownButton>
            </div>
        </div>
    );
}

export default GamesFilters;
